import { 
  useResetUserQuizMutation, 
  useCreateQuizMutation, 
  useCompleteQuizMutation, 
  useDeleteQuizByPageMutation 
} from '../quizesApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useQuizesActions = () => {
  const [resetUserQuizTrigger] = useResetUserQuizMutation();
  const [createQuizTrigger] = useCreateQuizMutation();
  const [completeQuizTrigger] = useCompleteQuizMutation();
  const [deleteQuizByPageTrigger] = useDeleteQuizByPageMutation();

  const resetUserQuiz = async ({ quiz, userId, courseId }) => {
    try {
      const result = await resetUserQuizTrigger({ quiz, userId, courseId }).unwrap();
      enqueueSnackbar(i18next.t('quiz.resetQuizResults'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('quiz.resetQuizResultsFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const createQuiz = async (quizData) => {
    try {
      const result = await createQuizTrigger(quizData).unwrap();
      enqueueSnackbar(i18next.t('quiz.quizCreated'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('quiz.quizCreatedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const completeQuiz = async ({ pageId }) => {
    try {
      const result = await completeQuizTrigger({ pageId }).unwrap();
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('quiz.completeQuizFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  const deleteQuizByPage = async ({ quizId, courseId }) => {
    try {
      const result = await deleteQuizByPageTrigger({ quizId, courseId }).unwrap();
      enqueueSnackbar(i18next.t('quiz.quizDeleted'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('quiz.quizDeletedFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    resetUserQuiz,
    createQuiz,
    completeQuiz,
    deleteQuizByPage,
  };
};
